















import Vue, { PropType } from 'vue';
import { InputState } from '../forms.types';
import { Icon } from '../../../basic';
import { Input } from '../';
import InputWrapper from '../bases/InputWrapper/InputWrapper.vue';
import { Button } from '../../buttons';
import BaseFormElem from '../bases/BaseFormElem.vue';

export default Vue.extend({
  name: 'NumberButtonInput',
  extends: BaseFormElem,
  components: { Input, Icon, Button, InputWrapper },
  props: {
    placeholder: {
      type: String,
    },
    value: String,
    state: {
      type: String as PropType<InputState>,
      default: 'default',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    min: String,
    max: String,
  },
  data() {
    return {
      iconSize: 58,
    };
  },
  mounted() {
    if ((this.$refs.button as Vue).$el.clientHeight) {
      this.iconSize = (this.$refs.button as Vue).$el.clientHeight;
    }
  },
  updated() {
    if ((this.$refs.button as Vue).$el.clientHeight) {
      this.iconSize = (this.$refs.button as Vue).$el.clientHeight;
    }
  },
  methods: {
    emitInput(val: string) {
      this.$emit('input', val);
    },
    decreaseValue() {
      let newValue = Number(this.value || 0) - 1;
      if (this.min !== undefined) {
        newValue = Math.max(newValue, Number(this.min));
      }

      this.emitInput(newValue.toString());
    },
    increaseValue() {
      let newValue = Number(this.value || 0) + 1;
      if (this.max !== undefined) {
        newValue = Math.min(newValue, Number(this.max));
      }

      this.emitInput(newValue.toString());
    },
  },
});
